var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from 'antd';
import { DiscordIcon, EmailIcon, SkypeIcon } from '../../helpers/icons';
import styles from './SupportsContacts.module.scss';
export var SupportsContacts = function () {
    return (_jsxs("div", __assign({ className: styles.contactsContainer }, { children: [_jsx(Button, { icon: _jsx(DiscordIcon, {}), size: 'large', target: '_blank', href: 'https://discord.com/invite/QYzvfuwtwc', className: styles.modalButtonDiscord }), _jsx(Button, { icon: _jsx(EmailIcon, {}), size: 'large', target: '_blank', href: 'mailto:support@simplepoker.com', className: styles.modalButton }), _jsx(Button, { icon: _jsx(SkypeIcon, {}), size: 'large', target: '_blank', href: 'skype:SimplePoker?chat', className: styles.modalButton })] })));
};
